import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiFormLabel-root": {
			transform: "translate(14px, -6px) scale(0.75) ",
			backgroundColor: "#FFFF",
			transition: "none !important",
			left: -3.5,
			padding: "0 5px",
		},
		"& .MuiInputBase-input": {
			backgroundColor: "#FFFF",
			color: "black",
			paddingRight: 45,
		},
		"& .MuiInputBase-root": {
			width: "100%",
		},
	},
}));

interface SearchFilterProps {
	searchText: string;
	onSearchChange: (value: string) => void;
}

export const SearchFilter: React.FC<SearchFilterProps> = ({
	searchText,
	onSearchChange,
}) => {
	const classes = useStyles();

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		onSearchChange(e.target.value);
	};

	return (
		<div
			style={{
				position: "relative",
				display: "flex",
				alignItems: "center",
				height: "45px",
				width: "100%",
			}}
		>
			<TextField
				className={classes.root}
				style={{ borderTopLeftRadius: 3, borderTopRightRadius: 3 }}
				label="Search Metrics"
				variant="outlined"
				margin="dense"
				value={searchText}
				onChange={handleChange}
				fullWidth
				autoComplete="off"
			/>
			<i
				className="fa fa-search"
				style={{
					position: "absolute",
					right: 17,
					top: 17,
					cursor: "pointer",
				}}
			/>
		</div>
	);
};
